import { useAuth } from "@/context/AuthContext";
import { Gear, EnvelopeSimple, Lock, Database } from "@phosphor-icons/react";

export default function Settings() {
  const { user } = useAuth();
  const backend = process.env.REACT_APP_BACKEND_URL;

  return (
    <div className="space-y-6 max-w-3xl" data-testid="settings-root">
      <div>
        <div className="text-xs font-bold uppercase tracking-[0.2em] text-slate-500">System</div>
        <h1 className="mt-1 text-3xl sm:text-4xl font-extrabold tracking-tight text-slate-900">Settings</h1>
        <p className="mt-1 text-sm text-slate-600">Read-only view of your current configuration.</p>
      </div>

      <div className="rounded-lg border border-slate-200 bg-white">
        <div className="px-6 py-4 border-b border-slate-200 flex items-center gap-2">
          <Gear size={20} weight="duotone" className="text-[#253c80]" />
          <h3 className="text-lg font-bold text-slate-900">Account</h3>
        </div>
        <div className="px-6 py-5 space-y-4">
          <Row icon={EnvelopeSimple} label="Email" value={user?.email} />
          <Row icon={Lock} label="Role" value={user?.role || "admin"} />
          <Row icon={Database} label="API Endpoint" value={`${backend}/api`} mono />
        </div>
      </div>

      <div className="rounded-lg border border-amber-200 bg-amber-50/60 p-6 text-sm text-amber-900">
        <strong className="font-semibold">Heads up:</strong> Password changes & dealer management UIs will arrive in
        the next iteration. For now, update <code className="bg-amber-100 px-1 rounded">ADMIN_PASSWORD</code> in
        <code className="bg-amber-100 px-1 rounded">backend/.env</code> and restart the backend.
      </div>
    </div>
  );
}

function Row({ icon: Icon, label, value, mono }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div className="flex items-center gap-2.5">
        <Icon size={18} weight="duotone" className="text-slate-500" />
        <span className="text-sm font-medium text-slate-700">{label}</span>
      </div>
      <span className={`text-sm text-slate-900 ${mono ? "font-mono text-xs" : ""}`}>{value}</span>
    </div>
  );
}
